import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export const plotsReportingApi = createApi({
    reducerPath: 'plotsApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getPlot: builder.query({
            query: ({ data }) => ({
                url: '/plots/get_plot',
                method: 'POST',
                body: { 'data': data }
            }),
        })
    }
    ),
});

export const {
    useGetPlotQuery
} = plotsReportingApi;

export default plotsReportingApi.reducer;